// src/components/ads/AdInsetSync.tsx
import { useEffect } from 'react'
import { startAdInsetWatcher } from '../../lib/adInset'

/**
 * Keeps `--ad-inset-bottom` on <html> in step with the Mediavine adhesion ad
 * (src/lib/adInset.ts). Renders nothing and mounts once at the app root next
 * to MediavineProSync, because the ad is about the whole page. With no ad
 * (Pro, blocked, or not served yet) the variable is 0px and nothing moves.
 */
export default function AdInsetSync() {
  useEffect(() => startAdInsetWatcher(), [])
  return null
}
